const css = `.FE8n5a__container{cursor:pointer;border-bottom:1px solid #e4e8eb}.FE8n5a__container:hover{text-decoration:none}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"container":"FE8n5a__container"};
